<template>
  <div style="position: relative">
    <template
      v-if="['text', 'password', 'email', 'number', 'date-simple', 'searchMap'].includes(inputType)"
    >
      <ion-input
        :id="dynamicId"
        :type="showType(type)"
        :value="inputValue"
        mode="md"
        shape="round"
        :class="className"
        :label="label"
        label-placement="stacked"
        :name="name"
        :clearable="!hideClear"
        fill="outline"
        :placeholder="placeholder ?? ''"
        @input="handleClickChange"
        :clear-input="clearField"
      >
        <ion-icon v-if="icon" slot="start" :icon="icon" inner="true" :color="iconColor"></ion-icon>
        <ion-input-password-toggle
          v-if="type === 'password'"
          slot="end"
        ></ion-input-password-toggle>
      </ion-input>
      <template v-if="inputType == 'searchMap'">
        <section v-if="results.length > 0" class="popover-wrapper">
          <ion-list>
            <template v-for="result in results" :key="result">
              <ion-item color="white" :button="true" @click="selectCity(result)"
                >{{ result.fullAddress }}
              </ion-item>
            </template>
          </ion-list>
        </section>
      </template>
    </template>
    <template v-if="['checkbox'].includes(inputType)">
      <ion-item lines="none" class="lodgerin-ion-item" color="white">
        <ion-checkbox
          :id="dynamicId"
          slot="start"
          :checked="inputValue"
          label-placement="end"
          justify="space-between"
          class="text-sm"
          @update:model-value="handleClickBlur"
          mode="ios"
        ></ion-checkbox>
        <slot name="checkbox-label">
          <ion-label class="text-xs text-color-body">{{ label }}</ion-label>
        </slot>
      </ion-item>
    </template>
    <template v-if="['date'].includes(inputType)">
      <VueDatePicker
        :clearable="!hideClear"
        :disabled="disabled"
        :start-date="startDate"
        :model-value="inputValue"
        @update:model-value="handleClickChange"
        @cleared="handleClickChange"
        auto-apply
        :placeholder="placeholder"
        model-type="yyyy-MM-dd"
        :min-date="minDate"
        :max-date="maxDate"
        locale="es"
        :enable-time-picker="false"
        :format="formatDate"
        position="center"
        :teleport="true"
      >
        <template #input-icon>
          <ion-icon
            v-if="icon"
            slot="start"
            :icon="icon"
            inner="true"
            :color="iconColor"
            style="margin-left: 30px"
          ></ion-icon>
        </template>
      </VueDatePicker>
    </template>
    <template v-if="['radio'].includes(inputType)">
      <ion-radio-group :value="inputType" @ion-change="handleClickBlur">
        <template v-for="(option, value) in options" :key="option">
          <ion-item lines="none" color="white">
            <ion-label class="custom-radio">{{ option }}</ion-label>
            <ion-radio color="primary" slot="start" :value="value"></ion-radio>
          </ion-item>
        </template>
      </ion-radio-group>
    </template>
    <template v-if="['select'].includes(inputType)">
      <ion-select
        mode="md"
        v-model="inputValue"
        fill="outline"
        color="primary"
        :label="label"
        label-placement="stacked"
        :value="inputType"
        @update:model-value="(val: any) => handleClickBlur(val)"
      >
        <ion-select-option :value="item.key" v-for="item in items" :key="item.key"
          >{{ item.value }}
        </ion-select-option>
      </ion-select>
    </template>
    <template v-if="['dial-code'].includes(inputType)">
      <ion-input
        :id="dynamicId"
        :type="showType(type)"
        :value="inputValue"
        mode="md"
        shape="round"
        :class="className"
        :label="label"
        label-placement="stacked"
        :name="name"
        fill="outline"
        :placeholder="placeholder ?? ''"
        @click="onfocusCode()"
        :clear-input="clearField"
        :readonly="readOnly"
      >
        <ion-avatar
          v-if="countrySelected"
          slot="start"
          style="width: 25px; height: 25px; margin-right: 5px"
        >
          <ion-img :src="countrySelected?.image"></ion-img>
        </ion-avatar>
      </ion-input>
      <ion-modal
        ref="modal"
        :is-open="isSearchModalOpen"
        :initial-breakpoint="0.75"
        :breakpoints="[0, 0.25, 0.5, 0.75]"
        @ion-modal-will-close="isSearchModalOpen = false"
      >
        <ion-content class="ion-padding">
          <h3 class="h3 mt-8 mb-16">{{ t('profile.areaCode') }}</h3>
          <ion-searchbar
            ref="SearchModal"
            color="white"
            v-model="searchCountry"
            :placeholder="t('profile.enterCountryName')"
          ></ion-searchbar>
          <ion-list>
            <ion-item
              v-for="country in optionsCountries"
              :key="country.code"
              button
              class="py-sm"
              @click="selectDialCodeCountry(country)"
            >
              <ion-avatar slot="start" style="width: 25px; height: 25px; margin-right: 5px">
                <ion-img :src="country.image"></ion-img>
              </ion-avatar>
              <ion-label>
                <p>{{ getCountryName(country.code) }} +{{ country.dialCode }}</p>
              </ion-label>
            </ion-item>
          </ion-list>
        </ion-content>
      </ion-modal>
    </template>
    <template v-if="['nationality'].includes(inputType)">
      <ion-input
        :id="dynamicId"
        :type="showType(type)"
        :value="inputValue"
        mode="md"
        shape="round"
        :class="className"
        :label="label"
        label-placement="stacked"
        :name="name"
        fill="outline"
        :placeholder="placeholder ?? ''"
        @click="onNationalityFocus"
        :clear-input="clearField"
        :readonly="readOnly"
      >
        <ion-label v-if="nationalitySelected" slot="start" class="hide-value">{{
          nationalitySelected[`name_${language}` as keyof typeof nationalitySelected]
        }}</ion-label>
      </ion-input>
      <ion-modal
        ref="modal"
        :is-open="isNationalityModalOpen"
        :initial-breakpoint="0.75"
        :breakpoints="[0, 0.25, 0.5, 0.75]"
        @ion-modal-will-close="isNationalityModalOpen = false"
      >
        <ion-content class="ion-padding">
          <h3 class="h3 mt-8 mb-16">{{ t('profile.nationalityTitle') }}</h3>
          <ion-searchbar
            color="white"
            ref="nationalityModal"
            v-model="searchNationality"
            :placeholder="t('profile.nationalitySearch')"
          ></ion-searchbar>
          <ion-list>
            <ion-item
              v-for="nationality in optionsNationalities"
              :key="nationality.name_en"
              button
              class="py-sm text-color-placeholder"
              @click="selectNationality(nationality)"
            >
              <ion-label>
                <p>{{ nationality[`name_${language}` as keyof typeof nationality] }}</p>
              </ion-label>
            </ion-item>
          </ion-list>
        </ion-content>
      </ion-modal>
    </template>
    <ion-text
      class="ion-padding text-small text-align-left display-block"
      color="danger"
      v-if="errorMessage && errorMessage.length > 0"
    >
      {{ errorMessage }}
    </ion-text>
  </div>
</template>
<script setup lang="ts">
  import VueDatePicker from '@vuepic/vue-datepicker';
  import {
    IonCheckbox,
    IonIcon,
    IonInput,
    IonInputPasswordToggle,
    IonItem,
    IonList,
    IonLabel,
    IonText,
    IonRadioGroup,
    IonRadio,
    IonSelect,
    IonSelectOption,
    IonSearchbar,
    IonImg,
    IonAvatar,
    IonContent,
    IonModal,
  } from '@ionic/vue';
  import { useField } from 'vee-validate';
  import { TextFieldTypes } from '@/utils/forms/schemas';
  import { Capacitor } from '@capacitor/core';
  import { computed, defineEmits, defineProps, onMounted, ref, toRef, watch } from 'vue';
  import dayjs from 'dayjs';
  import dayjsPluginUTC from 'dayjs-plugin-utc';
  import dayjsTimezone from 'dayjs-timezone-iana-plugin';
  import { format } from 'date-fns';
  import { storeToRefs } from 'pinia';
  import { useMapsStore } from '@/stores/maps-store';
  import { countries } from '@/utils/constants/country-codes';
  import { ICountry, Nationality } from '@/interfaces/maps/maps.interface';
  import { useMap } from '@/composables/useMap';
  import { useI18n } from 'vue-i18n';
  import { PlaceLocation } from '@/interfaces/elastic/elastic.interface';

  const { t } = useI18n();

  const { results } = storeToRefs(useMapsStore());
  const { searchDirection } = useMapsStore();
  const { nationalities, handleGetNationalities } = useMap();

  dayjs.extend(dayjsPluginUTC);
  dayjs.extend(dayjsTimezone);

  interface Props {
    modelValue: string | boolean | number | undefined;
    formName: string;
    inputType: string;
    type?: TextFieldTypes;
    value?: string | boolean | number | undefined;
    options?: string[] | { id: string | number; label: string }[] | undefined;
    name: string;
    label: string;
    icon?: string;
    iconColor?: string;
    successMessage?: string;
    placeholder?: string;
    clearField?: boolean;
    readOnly?: boolean;
    className?: string;
    minDate?: string | undefined;
    maxDate?: string | undefined;
    itemId?: string | undefined;
    itemName?: string | undefined;
    disabled?: boolean;
    hideClear?: boolean;
    language?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    type: 'text',
    iconColor: 'primary',
    clearField: true,
    readOnly: false,
    className: 'custom-field',
  });

  export interface formFilter {
    minPrice?: number;
    maxPrice?: number;
    lat?: number;
    lon?: number;
    PropertyTypeId: number;
    city: string;
    startAvailabilityDate: string;
    endAvailabilityDate: string;
    countryCode: string;
    country: string;
  }

  const filters = ref<formFilter>({
    minPrice: undefined,
    maxPrice: undefined,
    lon: undefined,
    lat: undefined,
    PropertyTypeId: -1,
    city: '',
    countryCode: '',
    country: '',
    startAvailabilityDate: '',
    endAvailabilityDate: '',
  });

  const nameRef = toRef(props, 'name');
  const isPopoverSearchMapOpen = ref(false);
  const isSearchModalOpen = ref(false);
  const isNationalityModalOpen = ref(false);
  const searchCountry = ref<string>('');
  const searchNationality = ref<string>('');
  const countrySelected = ref<ICountry | undefined>({
    name: 'Spain',
    code: 'ES',
    dialCode: '34',
    image: 'https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ES.svg',
  });
  const nationalitySelected = ref<Nationality | undefined>();

  const onNationalityFocus = async () => {
    isNationalityModalOpen.value = false;
    setTimeout(() => {
      isNationalityModalOpen.value = true;
    }, 5);
  };
  const onfocusCode = async () => {
    isSearchModalOpen.value = false;
    setTimeout(() => {
      isSearchModalOpen.value = true;
    }, 5);
  };

  const dynamicId = computed(() => {
    return `input-${props.formName}-${props.name}`;
  });

  const items = computed(() => {
    return props.options?.map((item: any) => ({
      key: props.itemId ? item[props.itemId] : item,
      value: props.itemName ? item[props.itemName] : item,
    }));
  });

  const startDate = computed(() => {
    if (props.name === 'birthdate') {
      return dayjs().subtract(18, 'year').format('YYYY-MM-DDTHH:mm:ss');
    } else {
      const minDate = dayjs(props.minDate);
      return minDate.format('YYYY-MM-DDTHH:mm:ss');
    }
  });

  const minDate = computed(() => {
    if (props.name === 'birthdate') {
      return dayjs().subtract(80, 'year').format('YYYY-MM-DDTHH:mm:ss');
    } else {
      if (props.minDate) {
        const minDate = dayjs(props.minDate);
        return minDate.format('YYYY-MM-DDTHH:mm:ss');
      } else {
        return props.minDate;
      }
    }
  });

  const maxDate = computed(() => {
    if (props.name === 'birthdate') {
      return dayjs().subtract(18, 'year').format('YYYY-MM-DDTHH:mm:ss');
    } else {
      return dayjs().add(80, 'year').format('YYYY-MM-DDTHH:mm:ss');
    }
  });

  const searchCountryCode = (country: ICountry) => {
    const searchedInput = nationalities.value.filter((nat) =>
      (nat[`name_${props.language}` as keyof typeof nat] as string)
        .toLowerCase()
        .includes(searchCountry.value.toLowerCase()),
    );
    const countryCodes = searchedInput.map((nat) => nat.countryCode);

    return countryCodes.includes(country.code);
  };

  const optionsCountries = computed<ICountry[]>(() => {
    if (props.inputType == 'dial-code') {
      return countries
        .filter(
          (country) =>
            searchCountryCode(country) ||
            country.dialCode.includes(searchCountry.value.toLowerCase()),
        )
        .map((item: ICountry) => item);
    } else {
      return [];
    }
  });

  const optionsNationalities = computed<Nationality[]>(() => {
    if (props.inputType == 'nationality') {
      return nationalities.value
        .filter((nationality: Nationality) =>
          (nationality[`name_${props.language}` as keyof typeof nationality] as string)
            .toLowerCase()
            .includes(searchNationality.value.toLowerCase()),
        )
        .map((item: Nationality) => item);
    } else {
      return [];
    }
  });

  const {
    value: inputValue,
    errorMessage,
    handleChange,
  } = useField<any>(nameRef, undefined, {
    initialValue:
      props.name == 'birthdate'
        ? dayjs().subtract(18, 'year').format('YYYY-MM-DDTHH:mm:ss')
        : props.value,
  });

  const emit = defineEmits(['update:modelValue', 'getLocation']);

  const formatDate = (date: any) => {
    return format(new Date(date), 'MMMM d, yyyy');
  };

  const selectDialCodeCountry = (country: ICountry) => {
    countrySelected.value = country;
    inputValue.value = country.dialCode;
    isSearchModalOpen.value = false;
    emit('update:modelValue', country.dialCode);
  };

  const selectNationality = (nationality: Nationality) => {
    nationalitySelected.value = nationality;
    inputValue.value = nationality.id;
    isNationalityModalOpen.value = false;
    emit('update:modelValue', nationality.id);
  };

  const handleClickChange = (e: any) => {
    handleChange(e);
    /* if (props.inputType === 'checkbox') {
      inputValue.value = e;
      emit('update:modelValue', e);
    } */
    if (props.inputType === 'date') {
      if (e) {
        inputValue.value = dayjs(e).format('YYYY-MM-DD');
      } else {
        inputValue.value = null;
      }
      emit('update:modelValue', e);
    } else {
      emit('update:modelValue', (e.target as HTMLInputElement).value);
    }

    if (props.inputType === 'searchMap') {
      const query = e.target.value.toLowerCase();

      if (query.length > 3) {
        filters.value.city = '';
        searchDirection(query);
        if (results.value) {
          isPopoverSearchMapOpen.value = true;
        }
      } else {
        results.value = [];
      }
    }
  };

  const handleClickBlur = (e: any) => {
    emit('update:modelValue', e);
  };

  const selectCity = (location: PlaceLocation) => {
    inputValue.value = location.city;
    results.value = [];
    emit('update:modelValue', location.city);
    emit('getLocation', location);
  };

  const showType = (type: any) => {
    if (type === 'date-simple') {
      return 'date';
    }
    if (type === 'textarea') {
      return 'text';
    }
    if (type === 'float') {
      return Capacitor.isNativePlatform() ? 'number' : 'text';
    }
    return type;
  };

  watch(props, () => {
    inputValue.value = props.modelValue;
    if (props.inputType == 'dial-code') {
      countrySelected.value = countries.find((country) => country.dialCode === props.modelValue);
    }
    if (props.inputType == 'nationality') {
      nationalitySelected.value = nationalities.value.find(
        (nationality) => nationality.id === props.modelValue,
      );
    }
  });

  const getCountryName = (code: string) => {
    const city = nationalities.value.find((nationality) => nationality.countryCode === code);

    return city ? city[`name_${props.language}` as keyof typeof city] : '';
  };

  onMounted(() => {
    if (props.inputType == 'nationality') {
      handleGetNationalities().then(() => {
        if (props.inputType == 'nationality') {
          nationalitySelected.value = nationalities.value.find(
            (nationality) => nationality.id === props.modelValue,
          );
        }
      });
    }
    if (props.modelValue) {
      inputValue.value = props.modelValue;
    }
    if (props.inputType == 'select') {
      inputValue.value = props.modelValue;
    }
    if (props.inputType == 'dial-code') {
      countrySelected.value = countries.find((country) => country.dialCode === props.modelValue);
    }
  });
</script>

<style scoped lang="scss">
  .popover-wrapper {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 10px;
    border-radius: 4px;
  }

  .custom-radio {
    color: var(--ion-color-body); /* Replace with any Ionic color or hex */
  }

  ion-radio {
    --border-radius: 4px;
    --inner-border-radius: 4px;
    --color: #ddd;
    --color-checked: var(--ion-color-primary);
  }

  ion-radio.ios::part(container) {
    width: 20px;
    height: 20px;

    border: 2px solid #ddd;
    border-radius: 4px;
  }

  .radio-checked.ios::part(container) {
    border-color: var(--ion-color-primary);
  }

  .dp__theme_light {
    --dp-text-color: #212121;
    --dp-cell-border-radius: 100px;
    --dp-font-family: 'Satoshi', sans-serif;
    --dp-font-size: 16px;
    --dp-common-padding: 100px;
    --dp-row-margin: 5px 0;
    --dp-primary-color: red;
    --dp-secondary-color: #c0c4cc;
    --dp-background-color: #fff;
  }

  ion-content {
    --background: white;
  }

  ion-list {
    background: white;
  }

  ion-item {
    --background: white;
  }

  input[name='nationality'] {
    --background: #1d3fb3;
    display: none;
  }

  .searchbar-input {
    background: white !important;
  }

  .searchbar-input {
    background: white !important;
  }
</style>
